import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { loadingBarReducer } from "react-redux-loading-bar";

import {
  mediasReducerByType,
  albumReducer,
  categoriesReducer,
  uploadingMediasReducer,
  authReducer,
  visibleSearchLayerReducer,
  languageReducer,
  currentNavPageReducer,
  masonryReducer,
  sourcesTokensReducer,
  notificationsReducer,
  filterReducer,
  tagsSuggestionsReducer,
  lightboxReducer,
  imageEditorReducer,
  mediaEditorReducer,
  albumEditorReducer,
  pdfViewerReducer,
  videoViewerReducer,
  eventReducer,
  maskSelectorReducer,
  logoSelectorReducer,
  fetchingReducer,
  menuReducer,
  usedMediasReducer,
  settingsReducer,
  usersReducer,
  articlesReducer,
  topicsReducer,
  treesReducer,
  notifsReducer,
  mediaViewerReducer,
  commentReducer,
  socialReducer,
  displayAlbumReducer,
  mediasListingReducer,
  topMediasReducer,
  mediasLogoReducer,
  mediasMaskReducer
} from "Reducers";

export const createReducer = () =>
  combineReducers({
    auth: authReducer,
    fetching: fetchingReducer,
    medias: combineReducers({
      listing: mediasListingReducer(),
      topMedias: topMediasReducer(),
      all: mediasReducerByType("ALL"),
      images: mediasReducerByType("IMAGE"),
      videos: mediasReducerByType("VIDEO"),
      pdfs: mediasReducerByType("PDF"),
      ppts: mediasReducerByType("PPT"),
      albums: mediasReducerByType("ALBUM"),
      masks: mediasMaskReducer("MASK"),
      logos: mediasLogoReducer("LOGO"),
      cat_0: mediasReducerByType("CAT_0"),
      cat_1: mediasReducerByType("CAT_1"),
      cat_2: mediasReducerByType("CAT_2"),
      cat_3: mediasReducerByType("CAT_3"),
      cat_4: mediasReducerByType("CAT_4"),
      uploading: uploadingMediasReducer
    }),
    albums: albumReducer,
    categories: categoriesReducer,
    params: combineReducers({
      lng: languageReducer,
      currentNavPage: currentNavPageReducer,
      masonry: masonryReducer,
      sourcesTokens: sourcesTokensReducer,
      notification: notificationsReducer,
      visibleSearchLayer: visibleSearchLayerReducer,
      menu: menuReducer
    }),
    filter: combineReducers({
      filterState: filterReducer,
      // categories: categoriesReducer,
      // authors: authorsReducer,
      // tags: tagsReducer,
      tagsSuggestions: tagsSuggestionsReducer
    }),
    lightbox: lightboxReducer,
    imageEditor: imageEditorReducer,
    mediaEditor: mediaEditorReducer,
    albumEditor: albumEditorReducer,
    pdfViewer: pdfViewerReducer,
    videoViewer: videoViewerReducer,
    maskSelector: maskSelectorReducer,
    logoSelector: logoSelectorReducer,
    routing: routerReducer,
    loadingBar: loadingBarReducer,
    eventFired: eventReducer,
    settings: settingsReducer,
    users: usersReducer,
    articles: articlesReducer,
    topics: topicsReducer,
    trees: treesReducer,
    notifs: notifsReducer,
    viewer: mediaViewerReducer,
    comments: commentReducer,
    usedMedias: usedMediasReducer,
    social: socialReducer,
    displayAlbum: displayAlbumReducer
  });



// WEBPACK FOOTER //
// ./src/store/createReducer.js